import { Mobile } from '../core'

$.fn.HomeHero = function() {
  let self = this

  if (self.data('home-hero')) {
    return self.data('home-hero')
  }

  self.markup = self.detach()
  self.vertical_checker = new Mobile('(orientation: portrait)', '(orientation: landscape)')
  self.hover_timeout = undefined
  self.has_entered = false

  self.mouse_moved = function(e) {
    if ($('html').hasClass('has-touch')) {
      return
    }
    if (!self.has_entered) {
      self.enter()
    }
    let moveX, moveY
    if ($('html').hasClass('has-touch')) {
      moveX = -(($(window).width() / 2) - e.originalEvent.pageX) / 2.25
      moveY = -(($(window).height() / 2) - e.originalEvent.pageY) / 3.5
    } else {
      moveX = -(($(window).width() / 2) - e.clientX) / 2.25
      moveY = -(($(window).height() / 2) - e.clientY) / 3.5
    }
    $('.home-hero--selected .home-hero__shape').css({
      'margin-top': moveY + 'px',
      'margin-left': moveX + 'px',
    })
  }

  self.enter = function() {
    self.has_entered = true
    self.addClass('entering')
    self.hover_timeout = setTimeout(function() {
      self.removeClass('entering').addClass('hovered')
    }, 300)
  }

  self.leave = function() {
    clearTimeout(self.hover_timeout)
    self.hover_timeout = undefined
    self.removeClass('hovered entering')
    $('.home-hero--selected .home-hero__shape').css({
      'margin-top': '',
      'margin-left': '',
    })
  }

  const maskScale = function() {
    let $selected = $('.home-hero--selected'),
    $layer = $selected.find('.home-hero__shape'),
    $masked_div = $layer.find('.masked-div'),
    zoneHeight = window.innerHeight - 250,
    shapeHeight = $layer.outerHeight(false) - 4000
    $masked_div.css({
      transform: 'scale(' + (zoneHeight / shapeHeight) + ')',
    })
  }

  self.initialize_desktop = function() {
    let $selected = $('.home-hero--selected'),
    $layer = $selected.find('.home-hero__shape'),
    $masked_div = $layer.find('.masked-div'),
    $shadow_div = $layer.find('.shadow-div'),
    $cutout_div = $layer.find('.shape-div'),
    $cutout_svg = $selected.find('svg'),
    $shadow_svg = $cutout_svg.clone()
    $shadow_div.append($shadow_svg)

    let $stroke_path = $shadow_svg.find('path'),
    $cutout_path = $cutout_svg.find('path'),
    width = $cutout_svg.get(0).viewBox.baseVal.width,
    height = $cutout_svg.get(0).viewBox.baseVal.height,
    padding_x = 6000,
    padding_y = 4000,
    viewbox = '0 0 ' + (width + padding_x) + ' ' + (height + padding_y)
    if (!$cutout_svg.data('isset')) {
      $cutout_svg.data('isset', true)
    }
    $cutout_svg.attr({
      viewBox: viewbox,
      width: width + padding_x,
      height: height + padding_y,
      style: '',
    })
    $shadow_svg.attr({
      width: width,
      height: height,
      style: '',
    }).css({
      height: 'auto',
      transform: 'translate(' + (padding_x / 2) + 'px, ' + (padding_y / 2) + 'px)',
      filter: 'blur(4px)',
      width: width + 'px',
    })
    $cutout_path.attr({
      'fill': '#FCF9F4',
      'fill-rule': 'evenodd',
      'stroke': '',
      'stroke-width': '',
    }).addClass('cutout-path')
    let $cutout_object = SVG.find('.cutout-path')
    $cutout_object.move(padding_x / 2, padding_y / 2)
    $cutout_path.attr('d', 'M0,0H' + (width + padding_x) + 'V' + (height + padding_y) + 'H0Z' + $cutout_path.attr('d'))
    $stroke_path.attr({
      'fill': 'transparent',
      'stroke': 'black',
      'stroke-width': '4px',
    })
    $layer.css({
      width: (width + padding_x) + 'px',
      height: (height + padding_y) + 'px',
    })
    $masked_div.css({
      width: (width + padding_x) + 'px',
      height: (height + padding_y) + 'px',
    })
    $(window).on('load resize', maskScale)
    maskScale()
  }

  const maskOffset = function() {
    let $image = $('.home-hero--selected .home-hero__image'),
    maskWidth = $image.height() * $image.data('ratio'),
    maskOffset = $image.data('offset'),
    maximumOffset = -Math.round(maskWidth - (window.innerWidth - 40)),
    maskPosition = ((maximumOffset * maskOffset / 12) + 20) + 'px 0'
    $image.css({
      'mask-position': maskPosition,
      '-webkit-mask-position': maskPosition
    })
  }

  self.initialize_mobile = function() {
    let $selected = $('.home-hero--selected'),
    $image = $selected.find('.home-hero__image')
    $image.css({
      'mask-image': 'url(' + $image.data('mask') + ')',
      '-webkit-mask-image': 'url(' + $image.data('mask') + ')',
    })
    $(window).on('load resize', maskOffset)
    maskOffset()
  }

  return function() {
    self.vertical_checker.add(function() {
      /* Portrait */
      $(window).off('load resize', maskScale)
      $('.home-hero').remove()
      $('.page-section').first().prepend(self.markup.clone().addClass('home-hero--mobile'))
      $('.home-hero').off('mouseenter mouseleave')
      self.initialize_mobile()
    }, function() {
      /* Landscape */
      $(window).off('load resize', maskOffset)
      $('.home-hero').remove()
      $('.app').before(self.markup.clone())
      self.initialize_desktop()
      self.leave()
      $('.home-hero').on('mouseenter', self.enter).on('mouseleave', self.leave)
      $('.home-hero').on('mousemove', self.mouse_moved)
    })
    self.data('home-hero', self)
    return self
  }()
}
